import { PropertiesService } from './properties.service'
import {
  FetchPropertiesRequest,
  FetchPropertiesSuccess,
  FetchPropertiesFailure,
  FetchPropertyRequest,
  FetchPropertySuccess,
  FetchPropertyFailure,
  UpdatePropertyRequest,
  UpdatePropertySuccess,
  UpdatePropertyFailure,
  FetchActiveFormSuccess,
  FetchActiveFormFailure,
  FetchActiveFormRequest,
  FetchPropertySettingsRequest,
  FetchPropertySettingsFailure,
  FetchPropertySettingsSuccess,
  CreatePropertySuccess,
  CreatePropertyRequest,
  CreatePropertyFailure,
  UploadPropertyImageRequest,
  UploadPropertyImageSuccess,
  UploadPropertyImageFailure,
  DeletePropertyImageRequest,
  DeletePropertyImageSuccess,
  DeletePropertyImageFailure,
  GeneratePropertyRDNsRequest,
  GeneratePropertyRDNsSuccess,
  GeneratePropertyRDNsFailure,
  UploadDocumentSuccess,
  UploadDocumentFailure,
  UploadDocumentRequest,
  DeleteDocumentRequest,
  DeleteDocumentFailure,
  DeleteDocumentSuccess,
  DeletePaymentRequest,
  DeletePaymentSuccess,
  DeletePaymentFailure,
  CreatePropertyPaymentRequest,
  CreatePropertyPaymentSuccess,
  CreatePropertyPaymentFailure,
  UpdatePropertyPaymentRequest,
  UpdatePropertyPaymentSuccess,
  UpdatePropertyPaymentFailure,
  GenerateCommercialLicensesSuccess,
  GenerateCommercialLicensesFailure,
  CalculateFeaturesFailure,
  CalculateFeaturesSuccess,
  CalculateFeaturesRequest,
  DownloadPropertyDocumentRequest,
  DownloadPropertyDocumentSuccess,
  DownloadPropertyDocumentFailure,
  DownloadPaymentReceiptRequest,
  DownloadPaymentReceiptSuccess,
  DownloadPaymentReceiptFailure,
  GeneratePaymentReportRequest,
  GeneratePaymentReportSuccess,
  GeneratePaymentReportFailure,
  GeneratePropertyReportRequest,
  GeneratePropertyReportSuccess,
  GeneratePropertyReportFailure,
  GeneratePropertyBusinessReportRequest,
  GeneratePropertyBusinessReportSuccess,
  GeneratePropertyBusinessReportFailure,
  GeneratePaymentTaxpayerReportRequest,
  GeneratePaymentTaxpayerReportSuccess,
  GeneratePaymentTaxpayerReportFailure,
  SetPropertyFieldVisitRequest,
  SetPropertyFieldVisitSuccess,
  SetPropertyFieldVisitFailure,
  GenerateBusinessLicenceReportRequest,
  GenerateBusinessLicenceReportSuccess,
  GenerateBusinessLicenceReportFailure,
  FetchPropertyDocumentsRequest,
  FetchPropertyDocumentsSuccess,
  FetchPropertyDocumentsFailure,
  FetchPropertyPaymentsRequest,
  FetchPropertyPaymentsSuccess,
  FetchPropertyPaymentsFailure,
  GeneratePropertyDocumentRequest,
  GeneratePropertyDocumentSuccess,
  GeneratePropertyDocumentFailure,
  FetchPropertyDynamicFieldsRequest,
  FetchPropertyDynamicFieldsSuccess,
  FetchPropertyDynamicFieldsFailure,
  FetchPropertyHistoryRequest,
  FetchPropertyHistorySuccess,
  FetchPropertyHistoryFailure,
  ArchivePropertyRequest,
  ArchivePropertySuccess,
  ArchivePropertyFailure,
  FetchPropertyBusinessesRequest,
  FetchPropertyBusinessesSuccess,
  FetchPropertyBusinessesFailure,
} from './properties.actions'
import { ShowSnackbar } from './../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as PropertiesTypes from './properties.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'
import { downloadBlob } from '@shared/shared.utils'

@Injectable()
export class PropertiesEffects {
  constructor(
    private actions: Actions,
    private propertiesService: PropertiesService,
    private router: Router,
  ) {}

  FetchProperties$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.FETCH_PROPERTIES_REQUEST),
      switchMap((action: FetchPropertiesRequest) => {
        return this.propertiesService
          .fetchProperties(action.propertyType, action.payload)
          .pipe(
            map((result) => {
              return new FetchPropertiesSuccess(
                result.data.results,
                result.data.totalCount,
                result.data.filteredCount,
              )
            }),
            catchError((err, caught) => {
              return of(new FetchPropertiesFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  GeneratePropertyRDNs$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.GENERATE_PROPERTY_RDNS_REQUEST),
      switchMap((action: GeneratePropertyRDNsRequest) => {
        return this.propertiesService.generatePropertyRDNs(action.id).pipe(
          map((result) => {
            return new GeneratePropertyRDNsSuccess(result.data.rdns)
          }),
          catchError((err, caught) => {
            return of(new GeneratePropertyRDNsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  GenerateCommercialLicenses$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.GENERATE_PROPERTY_COMMERCIAL_LICENSES_REQUEST),
      switchMap((action: GeneratePropertyRDNsRequest) => {
        return this.propertiesService
          .generatePropertyCommercialLicenses(action.id)
          .pipe(
            map((result) => {
              return new GenerateCommercialLicensesSuccess(
                result.data.commercialLicenses,
              )
            }),
            catchError((err, caught) => {
              return of(new GenerateCommercialLicensesFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  UploadDocument$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.UPLOAD_DOCUMENT_REQUEST),
      switchMap((action: UploadDocumentRequest) => {
        return this.propertiesService
          .uploadDocument(action.id, action.payload)
          .pipe(
            map((result) => {
              return new UploadDocumentSuccess(result.data.documents)
            }),
            catchError((err, caught) => {
              return of(new UploadDocumentFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  DeleteDocument$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.DELETE_DOCUMENT_REQUEST),
      switchMap((action: DeleteDocumentRequest) => {
        return this.propertiesService.deleteDocument(action.id).pipe(
          map((result) => {
            return new DeleteDocumentSuccess(result.data.documents)
          }),
          catchError((err, caught) => {
            return of(new DeleteDocumentFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeletePayment$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.DELETE_PAYMENT_REQUEST),
      switchMap((action: DeletePaymentRequest) => {
        return this.propertiesService.deletePayment(action.id).pipe(
          map((result) => {
            return new DeletePaymentSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new DeletePaymentFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchProperty$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.FETCH_PROPERTY_REQUEST),
      switchMap((action: FetchPropertyRequest) => {
        return this.propertiesService.fetchProperty(action.id).pipe(
          map((result) => {
            return new FetchPropertySuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchPropertyFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateProperty$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.UPDATE_PROPERTY_REQUEST),
      switchMap((action: UpdatePropertyRequest) => {
        return this.propertiesService
          .updateProperty(action.id, action.payload, action.nextStatus)
          .pipe(
            switchMap((result) => {
              if (action.nextStatus) {
                this.router.navigate([
                  `/properties/${action.nextStatus.toLowerCase()}`,
                ])
              }
              return [new UpdatePropertySuccess(result.data)]
            }),
            catchError((err, caught) => {
              return of(new UpdatePropertyFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  CreateProperty$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.CREATE_PROPERTY_REQUEST),
      switchMap((action: CreatePropertyRequest) => {
        return this.propertiesService.createProperty(action.payload).pipe(
          switchMap((result) => {
            this.router.navigate([`/properties/${result.data.id}/details`])
            return [new CreatePropertySuccess(result.data)]
          }),
          catchError((err, caught) => {
            return of(new CreatePropertyFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UploadPropertyImage$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.UPLOAD_PROPERTY_IMAGE_REQUEST),
      switchMap((action: UploadPropertyImageRequest) => {
        return this.propertiesService
          .uploadPropertyImage(action.id, action.payload)
          .pipe(
            switchMap((result) => {
              return [new UploadPropertyImageSuccess(result.data.images)]
            }),
            catchError((err, caught) => {
              return of(new UploadPropertyImageFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  DeletePropertyImage$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.DELETE_PROPERTY_IMAGE_REQUEST),
      switchMap((action: DeletePropertyImageRequest) => {
        return this.propertiesService
          .deletePropertyImage(action.id, action.imageTypeId)
          .pipe(
            switchMap((result) => {
              return [new DeletePropertyImageSuccess(result.data.images)]
            }),
            catchError((err, caught) => {
              console.log(err)
              return of(new DeletePropertyImageFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  FetchActiveForm$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.FETCH_ACTIVE_FORM_REQUEST),
      switchMap((action: FetchActiveFormRequest) => {
        return this.propertiesService.fetchActiveForm().pipe(
          map((result) => {
            return new FetchActiveFormSuccess(result.data.form.form)
          }),
          catchError((err, caught) => {
            return of(new FetchActiveFormFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchPropertySettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.FETCH_PROPERTY_SETTINGS_REQUEST),
      switchMap((action: FetchPropertySettingsRequest) => {
        return this.propertiesService.fetchPropertySettings().pipe(
          map((result) => {
            return new FetchPropertySettingsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchPropertySettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreatePropertyPayment$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.CREATE_PROPERTY_PAYMENT_REQUEST),
      switchMap((action: CreatePropertyPaymentRequest) => {
        return this.propertiesService
          .createPropertyPayment(action.payload)
          .pipe(
            switchMap((result) => {
              return [new CreatePropertyPaymentSuccess(result.data)]
            }),
            catchError((err, caught) => {
              return of(new CreatePropertyPaymentFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  UpdatePropertyPayment$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.UPDATE_PROPERTY_PAYMENT_REQUEST),
      switchMap((action: UpdatePropertyPaymentRequest) => {
        return this.propertiesService
          .updatePropertyPayment(action.payload)
          .pipe(
            switchMap((result) => {
              return [new UpdatePropertyPaymentSuccess(result.data)]
            }),
            catchError((err, caught) => {
              return of(new UpdatePropertyPaymentFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  CalculateFeatures$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.CALCULATE_FEATURES_REQUEST),
      switchMap((action: CalculateFeaturesRequest) => {
        return this.propertiesService.calculateFeatures(action.payload).pipe(
          switchMap((result) => {
            return [
              new CalculateFeaturesSuccess(action.payload.parent, result.data),
            ]
          }),
          catchError((err, caught) => {
            return of(new CalculateFeaturesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  GeneratePropertyDocument$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.GENERATE_PROPERTY_DOCUMENT_REQUEST),
      switchMap((action: GeneratePropertyDocumentRequest) => {
        return this.propertiesService
          .generatePropertyDocument(action.payload)
          .pipe(
            switchMap((result) => {
              return [new GeneratePropertyDocumentSuccess(result, null)]
            }),
            catchError((err, caught) => {
              return of(new GeneratePropertyDocumentFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  DownloadPropertyDocument$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.DOWNLOAD_PROPERTY_DOCUMENT_REQUEST),
      switchMap((action: DownloadPropertyDocumentRequest) => {
        return this.propertiesService
          .downloadPropertyDocument(action.payload)
          .pipe(
            switchMap((result) => {
              return [new DownloadPropertyDocumentSuccess(result, null)]
            }),
            catchError((err, caught) => {
              return of(new DownloadPropertyDocumentFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  SavePropertyDocument$ = createEffect(
    () =>
      this.actions.pipe(
        ofType<DownloadPropertyDocumentSuccess>(
          PropertiesTypes.DOWNLOAD_PROPERTY_DOCUMENT_SUCCESS,
        ),
        tap((action) => downloadBlob(action.payload)),
      ),
    { dispatch: false },
  )

  DownloadPaymentReceipt$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.DOWNLOAD_PAYMENT_RECEIPT_REQUEST),
      switchMap((action: DownloadPaymentReceiptRequest) => {
        return this.propertiesService
          .downloadPaymentReceipt(action.payment)
          .pipe(
            switchMap((result) => {
              return [new DownloadPaymentReceiptSuccess(result, action.payment)]
            }),
            catchError((err, caught) => {
              return of(new DownloadPaymentReceiptFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  SavePaymentReceipt$ = createEffect(
    () =>
      this.actions.pipe(
        ofType<DownloadPaymentReceiptSuccess>(
          PropertiesTypes.DOWNLOAD_PAYMENT_RECEIPT_SUCCESS,
        ),
        tap((action) => downloadBlob(action.payload)),
      ),
    { dispatch: false },
  )

  GeneratePaymentReport$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.GENERATE_PAYMENT_REPORT_REQUEST),
      switchMap((action: GeneratePaymentReportRequest) => {
        return this.propertiesService
          .generatePaymentReport(action.propertyId)
          .pipe(
            switchMap((result) => {
              return [
                new GeneratePaymentReportSuccess(result, action.propertyId),
              ]
            }),
            catchError((err, caught) => {
              return of(new GeneratePaymentReportFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  SavePaymentReport$ = createEffect(
    () =>
      this.actions.pipe(
        ofType<GeneratePaymentReportSuccess>(
          PropertiesTypes.GENERATE_PAYMENT_REPORT_SUCCESS,
        ),
        tap((action) => downloadBlob(action.payload)),
      ),
    { dispatch: false },
  )

  GeneratePaymentTaxpayerReport$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.GENERATE_PAYMENT_TAXPAYER_REPORT_REQUEST),
      switchMap((action: GeneratePaymentTaxpayerReportRequest) => {
        return this.propertiesService
          .generatePaymentTaxpayerReport(action.propertyId)
          .pipe(
            switchMap((result) => {
              return [
                new GeneratePaymentTaxpayerReportSuccess(
                  result,
                  action.propertyId,
                ),
              ]
            }),
            catchError((err, caught) => {
              return of(
                new GeneratePaymentTaxpayerReportFailure({ error: err }),
              )
            }),
          )
      }),
    ),
  )

  SavePaymentTaxpayerReport$ = createEffect(
    () =>
      this.actions.pipe(
        ofType<GeneratePaymentTaxpayerReportSuccess>(
          PropertiesTypes.GENERATE_PAYMENT_TAXPAYER_REPORT_SUCCESS,
        ),
        tap((action) => downloadBlob(action.payload)),
      ),
    { dispatch: false },
  )

  GenerateBusinessLicenceReport$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.GENERATE_BUSINESS_LICENCE_REPORT_REQUEST),
      switchMap((action: GenerateBusinessLicenceReportRequest) => {
        return this.propertiesService
          .generateBusinessLicenceReport(action.propertyId)
          .pipe(
            switchMap((result) => {
              return [
                new GenerateBusinessLicenceReportSuccess(
                  result,
                  action.propertyId,
                ),
              ]
            }),
            catchError((err, caught) => {
              return of(
                new GenerateBusinessLicenceReportFailure({ error: err }),
              )
            }),
          )
      }),
    ),
  )

  SaveBusinessLicenceReport$ = createEffect(
    () =>
      this.actions.pipe(
        ofType<GenerateBusinessLicenceReportSuccess>(
          PropertiesTypes.GENERATE_BUSINESS_LICENCE_REPORT_SUCCESS,
        ),
        tap((action) => downloadBlob(action.payload)),
      ),
    { dispatch: false },
  )

  GeneratePropertyReport$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.GENERATE_PROPERTY_REPORT_REQUEST),
      switchMap((action: GeneratePropertyReportRequest) => {
        return this.propertiesService
          .generatePropertyReport(action.propertyId, action.propertyType)
          .pipe(
            switchMap((result) => {
              return [
                new GeneratePropertyReportSuccess(
                  result,
                  action.propertyId,
                  action.propertyType,
                ),
              ]
            }),
            catchError((err, caught) => {
              return of(new GeneratePropertyReportFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  SavePropertyReport$ = createEffect(
    () =>
      this.actions.pipe(
        ofType<GeneratePropertyReportSuccess>(
          PropertiesTypes.GENERATE_PROPERTY_REPORT_SUCCESS,
        ),
        tap((action) => downloadBlob(action.payload)),
      ),
    { dispatch: false },
  )

  GeneratePropertyBusinessReport$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.GENERATE_PROPERTY_BUSINESS_REPORT_REQUEST),
      switchMap((action: GeneratePropertyBusinessReportRequest) => {
        return this.propertiesService
          .generatePropertyBusinessReport(action.businessId)
          .pipe(
            switchMap((result) => {
              return [
                new GeneratePropertyBusinessReportSuccess(
                  result,
                  action.businessId,
                ),
              ]
            }),
            catchError((err, caught) => {
              return of(
                new GeneratePropertyBusinessReportFailure({ error: err }),
              )
            }),
          )
      }),
    ),
  )

  SavePropertyBusinessReport$ = createEffect(
    () =>
      this.actions.pipe(
        ofType<GeneratePropertyBusinessReportSuccess>(
          PropertiesTypes.GENERATE_PROPERTY_BUSINESS_REPORT_SUCCESS,
        ),
        tap((action) => downloadBlob(action.payload)),
      ),
    { dispatch: false },
  )

  SetPropertyFieldVisit$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.SET_PROPERTY_FIELD_VISIT_REQUEST),
      switchMap((action: SetPropertyFieldVisitRequest) => {
        return this.propertiesService
          .setPropertyFieldVisit(action.appealId, action.payload)
          .pipe(
            switchMap((result) => {
              return [new SetPropertyFieldVisitSuccess(result.data)]
            }),
            catchError((err, caught) => {
              return of(new SetPropertyFieldVisitFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  FetchPayments$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.FETCH_PROPERTY_PAYMENTS_REQUEST),
      switchMap((action: FetchPropertyPaymentsRequest) => {
        return this.propertiesService.fetchPropertyPayments(action.id).pipe(
          map((result) => {
            return new FetchPropertyPaymentsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchPropertyPaymentsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchHistory$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.FETCH_PROPERTY_HISTORY_REQUEST),
      switchMap((action: FetchPropertyHistoryRequest) => {
        return this.propertiesService
          .fetchPropertyHistory(action.id, action.payload)
          .pipe(
            map((result) => {
              return new FetchPropertyHistorySuccess(
                result.data.results,
                result.data.totalCount,
                result.data.filteredCount,
              )
            }),
            catchError((err, caught) => {
              return of(new FetchPropertyHistoryFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  FetchDocuments$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.FETCH_PROPERTY_DOCUMENTS_REQUEST),
      switchMap((action: FetchPropertyDocumentsRequest) => {
        return this.propertiesService.fetchPropertyDocuments(action.id).pipe(
          map((result) => {
            return new FetchPropertyDocumentsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchPropertyDocumentsFailure({ error: err }))
          }),
        )
      }),
    ),
  )
  FetchDynamicFields$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.FETCH_PROPERTY_DYNAMIC_FIELDS_REQUEST),
      switchMap((action: FetchPropertyDynamicFieldsRequest) => {
        return this.propertiesService.fetchPropertyDynamicFields().pipe(
          map((result) => {
            return new FetchPropertyDynamicFieldsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchPropertyDynamicFieldsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  ArchiveProperty$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.ARCHIVE_PROPERTY_REQUEST),
      switchMap((action: ArchivePropertyRequest) => {
        return this.propertiesService.archiveProperty(action.id).pipe(
          switchMap((result) => {
            this.router.navigate([`/properties/archived`])

            return [new ArchivePropertySuccess(result.data)]
          }),
          catchError((err, caught) => {
            return of(new ArchivePropertyFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchPropertyBusinesses$ = createEffect(() =>
    this.actions.pipe(
      ofType(PropertiesTypes.FETCH_PROPERTY_BUSINESSES_REQUEST),
      switchMap((action: FetchPropertyBusinessesRequest) => {
        return this.propertiesService.fetchPropertyBusinesses(action.id).pipe(
          map((result) => {
            return new FetchPropertyBusinessesSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchPropertyBusinessesFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
